import request from '@/utils/request'
// eslint-disable-next-line no-unused-vars
import { data } from 'autoprefixer'

const sysModelApi = {

}

/**
 * 获取车型信息
 * @param data
 * @returns {AxiosPromise}
 */
sysModelApi.getModelList = data => {
  return request({
    url: '/sysModel/getList',
    method: 'post',
    data
  })
}

/**
 * 获取年份信息
 * @param data
 * @returns {AxiosPromise}
 */
sysModelApi.getYearList = seriesCode => {
  return request({
    // eslint-disable-next-line no-undef
    url: '/sysYear/getList/' + seriesCode,
    method: 'get'
  })
}

/**
 * 获取车系信息
 * @param data
 * @returns {AxiosPromise}
 */
sysModelApi.getSeriesList = data => {
  return request({
    url: '/sysSeries/getList',
    method: 'post',
    data
  })
}

// 车系反查
sysModelApi.getSeries = data => {
  return request({
    url: '/sysSeries/getListByYear',
    method: 'post',
    data
  })
}

// 车型导航默认下拉框选值  国内
sysModelApi.getTreeList = data => {
  return request({
    url: '/mdVehicleMaterial/getDropdown',
    method: 'post',
    data
  })
}

// 车型导航默认下拉框选值  海外-分表
sysModelApi.getTreeListOversea = data => {
  return request({
    url: '/overseasMdVehicleMaterial/getOverseaDropdown',
    method: 'post',
    data
  })
}

// 车型导航默认下拉框选值  海外
sysModelApi.getTreeOverseaList = data => {
  return request({
    url: '/mdVehicleMaterial/getOverseaDropdown',
    method: 'post',
    data
  })
}



// 车型导航系统-下拉菜单
sysModelApi.getVehicleGroupTree = data => {
  return request({
    url: '/admVehicleGroup/getVehicleGroup',
    method: 'post',
    data
  })
}

// 车型导航系统-下拉菜单-子菜单
sysModelApi.getChildGroupTree = code => {
  return request({
    url: '/admVehicleGroup/getVehicleSubGroup/' + code,
    method: 'get'
  })
}

// 获取pdf路径
sysModelApi.getPdfList = id => {
  return request({
    url: '/ebook/getDocPath/' + id,
    method: 'get'
  })
}

// 年份
sysModelApi.getYearList = () => {
  return request({
    url: '/sysYear/getList',
    method: 'get'
  })
}



sysModelApi.getSvgUrl = data => {
  return request({
    url: '/c3d/getC3dObjectPath',
    method: 'post',
    data
  })
}

// 获取手册表格数据
sysModelApi.getEbook = data => {
  return request({
    url: '/ebook/getPageList',
    method: 'post',
    data
  })
}

// 电路图菜单
sysModelApi.getVehicleSchematicTree = code => {
  return request({
    url: '/Cdiagram/getTree/' + code,
    method: 'get'
  })
}

// 获取车辆配置
sysModelApi.getVehConfigCookie = code => {
  return request({
    url: '/Cdiagram/getConfig/' + code,
    method: 'get'
  })
}

// 获取电路图url
sysModelApi.getSchematicUrl = id => {
  return request({
    url: '/ebook/getCdiagramPath/' + id,
    method: 'get'
  })
}

// 系统概述
sysModelApi.getMaterial = data => {
  return request({
    url: '/overview/getTree',
    method: 'post',
    data
  })
}

// 系统概述--url
sysModelApi.getSummaryUrl = id => {
  return request({
    url: '/overview/getOverviewPath/' + id,
    method: 'get'
  })
}

// 车型导航--类型
sysModelApi.getType = data => {
  return request({
    url: '/ebook/getDocType',
    method: 'post',
    data
  })
}

// 车型导航--子系统列表
sysModelApi.getDocSubGroup = data => {
  return request({
    url: '/ebook/getDocSubGroup',
    method: 'post',
    data
  })
}

// 海外查询-下拉菜单
sysModelApi.getInternetTreeList = data => {
  return request({
    url: '/overseasVehicleMaterial/getDropdown',
    method: 'post',
    data
  })
}

// 系统概述-懒加载
sysModelApi.getChildTreeSummary = id => {
  return request({
    url: '/overview/getChildTree/' + id,
    method: 'get'
  })
}

// 电路图等-懒加载
sysModelApi.getChildTreeCdiagram = id => {
  return request({
    url: '/Cdiagram/getChildTree/' + id,
    method: 'get'
  })
}

// 新工时表格
sysModelApi.getDismantleHours = code => {
  return request({
    url: '/admNewHoursDismantle/getDismantleHours/' + code,
    method: 'get'
  })
}

export default sysModelApi
